import * as React from "react";
import { useLiveQuery } from "dexie-react-hooks";
import { Form } from "react-bootstrap";
import { db } from "src/database/dexie";
import { MetricSeriesModal, type MetricSeriesEntity } from "./MetricSeriesModal";

const CREATE_NEW_SERIES = "__create_new_metric_series__";

interface Props {
  value: string;
  onChange(seriesId: string): void;
}

export function MetricSeriesSelect({ value, onChange }: Props) {
  const seriesList = useLiveQuery(() => db.metricSeries.orderBy("label").toArray(), []) ?? [];
  const [modalOpen, setModalOpen] = React.useState(false);

  const handleSeriesChange = (next: string) => {
    if (next === CREATE_NEW_SERIES) {
      setModalOpen(true);
      return;
    }
    onChange(next);
  };

  const handleModalSave = (series: MetricSeriesEntity) => {
    onChange(series.id);
  };

  return (
    <>
      <Form.Select
        value={value || ""}
        onChange={(e) => handleSeriesChange(e.target.value)}
        aria-label="Metric series"
      >
        <option value="">Select series…</option>
        {seriesList.map((row) => (
          <option key={row.id} value={row.id}>
            {row.label}
          </option>
        ))}
        <option value={CREATE_NEW_SERIES}>Create new series…</option>
      </Form.Select>
      <MetricSeriesModal
        show={modalOpen}
        onHide={() => setModalOpen(false)}
        onSave={handleModalSave}
      />
    </>
  );
}
